import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function Level12Illustration({
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-4058" data-mp="37ptv8kdjuhea">
      
      <div className="relative w-full h-full bg-gradient-to-br from-amber-200 via-yellow-300 to-orange-400 overflow-hidden" data-id="element-4059" data-mp="88casn2usvx2">
        {/* Background: Graduation glow */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4060" data-mp="3vl6bmkd1r02k">
          
          <circle cx="100" cy="95" r="78" fill="#FEF3C7" opacity="0.45" data-id="element-4061" data-mp="3ql0nhe5zjvp8" />
          <g style={{
          transformOrigin: '100px 100px'
        }} data-id="element-4062" data-mp="ryo3wc738fg2">
            
            {[...Array(12)].map((_, i) => <path key={i} d="M100 100 L96 6 L104 6 Z" fill="#FFFFFF" opacity="0.18" transform={`rotate(${i * 30} 100 100)`} data-id="element-4063" data-mp="n4bhbtabeo03" data-mpi={i} />)}
          </g>
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[8%]" data-id="element-4064" data-mp="7hipcyq7nk4b">
          <div className="w-[64%] h-[64%] flex items-center justify-center" data-id="element-4065" data-mp="3pv8f1ztx5ggu">
            <DjaySpecimen look={{
            variant
          }} size="hero" emotion={isUnlocked ? 'proud' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-4066" data-mp="3twtnn8zf78l8" />
            
          </div>
        </div>

        {/* Foreground: graduation cap + level badge */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4067" data-mp="36xnsizemmtze">
          
            <g transform="translate(100, 36)" data-id="element-4068" data-mp="3b0kbwsbzqu4e">
              <path d="M-28 0 L0 -12 L28 0 L0 12 Z" fill="#1E293B" data-id="element-4069" data-mp="156u4rouhj6gb" />
              <path d="M0 12 L0 22" stroke="#1E293B" strokeWidth="2" data-id="element-4070" data-mp="1974b52m6vyvp" />
              <circle cx="0" cy="24" r="3" fill="#FBBF24" data-id="element-4071" data-mp="1959y0ah5tb26" />
            </g>
            <circle cx="40" cy="40" r="18" fill="#B45309" data-id="element-4072" data-mp="2i5vzy0t8bmtw" />
            <text x="40" y="46" textAnchor="middle" fontFamily="sans-serif" fontSize="14" fontWeight="900" fill="white" data-id="element-4073" data-mp="2d4q6u1vnpxju">
            
              12
            </text>
          </svg>}
      </div>
    </DjayIllustrationBase>;
}